"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cat_1 = require("./cat");
var linear_1 = require("./linear");
var r_prettry_1 = require("./r-prettry");
var register_1 = require("./register");
exports.getTickMethod = register_1.getTickMethod;
var time_1 = require("./time");
var time_cat_1 = require("./time-cat");
var log_1 = require("./log");
var pow_1 = require("./pow");
var quantile_1 = require("./quantile");
var time_pretty_1 = require("./time-pretty");
register_1.registerTickMethod('cat', cat_1.default);
register_1.registerTickMethod('time-cat', time_cat_1.default);
register_1.registerTickMethod('wilkinson-extended', linear_1.default);
register_1.registerTickMethod('r-pretty', r_prettry_1.default);
register_1.registerTickMethod('time', time_1.default);
register_1.registerTickMethod('time-pretty', time_pretty_1.default);
register_1.registerTickMethod('log', log_1.default);
register_1.registerTickMethod('pow', pow_1.default);
register_1.registerTickMethod('quantile', quantile_1.default);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/scale/lib/tick-method/index.js
// module id = 1074
// module chunks = 37